/**
 * Transforms bot QA API payloads into Analytics panel view-model fields.
 */

const KPI_COLORS = {
  overall: "#7c3aed",
  empathy_tone: "#10b981",
  grammar_spelling: "#0d9488",
  response_time: "#f59e0b",
  personalization: "#ec4899",
  compliance_policy: "#6366f1",
  resolution_knowledge: "#14b8a6",
};

const KPI_LABELS = {
  overall: "Overall",
  empathy_tone: "Empathy & tone",
  grammar_spelling: "Grammar & spelling",
  response_time: "Response time",
  personalization: "Personalization",
  compliance_policy: "Compliance & policy",
  resolution_knowledge: "Resolution & knowledge",
};

export class BotQaViewModelDeriver {
  /**
   * @param {{ qaAnalysis: Record<string, unknown>, qaScorePercentages: Record<string, unknown> }} raw
   */
  build(raw) {
    const qa = raw.qaAnalysis && typeof raw.qaAnalysis === "object" ? raw.qaAnalysis : {};
    const pct =
      raw.qaScorePercentages && typeof raw.qaScorePercentages === "object"
        ? raw.qaScorePercentages
        : {};
    const scores =
      pct.score_percentages && typeof pct.score_percentages === "object"
        ? pct.score_percentages
        : {};
    const rt =
      qa.response_times && typeof qa.response_times === "object" ? qa.response_times : {};

    const total =
      Number(qa.total_conversations ?? pct.total_conversations ?? 0) || 0;

    const qaScoreRows = Object.keys(KPI_LABELS).map((key) => ({
      label: KPI_LABELS[key],
      value: Math.round(Number(scores[key]) || 0),
      color: KPI_COLORS[key],
    }));

    return {
      qaSummary: {
        totalConversations: total,
        averageOverallScore: Number(qa.average_overall_score) || 0,
        averageCsatRating: Number(qa.average_csat_rating) || 0,
        firstResponseAvg: Number(rt.first_response_avg) || 0,
        avgResponseAvg: Number(rt.avg_response_avg) || 0,
        periodName: String(pct.period_name ?? ""),
      },
      qaScoreRows,
      qaEmpty: total === 0,
    };
  }
}

export const botQaViewModelDeriver = new BotQaViewModelDeriver();
